export default "__VITE_ASSET__R1EX4L7R__"